import { Link } from "../types.d";
import { PlainTextProps } from "./types.d";

function formatList(items: readonly string[]): string {
  return `${items.map(item => `* ${item}`).join("\n")}`;
}

function formatInlineList(items: string[]): string {
  return `${items.map(item => `${item}`).join(" · ")}`;
}

function formatLinkList(items: readonly Link[]): string {
  return `${items
    .map(({ title, href }) => `* [${title}](${href})`)
    .join("\n")}`;
}

// TODO: check if image and use discription field then!

function getPlainText({
  body,
  by,
  creditLine,
  date,
  dpaContactsText,
  editorialnotes,
  edservices,
  genre,
  hasNotes,
  isEmbargoed,
  links,
  places,
  pubStatus,
  tags,
  time,
  title,
  tooltip
}: PlainTextProps) {
  const output: string[] = [];

  if (pubStatus && tooltip) {
    output.push(`
${pubStatus.toUpperCase()}
${tooltip}
`);
  }

  // @ts-ignore
  output.push(formatInlineList(tags.map((tag: any) => tag.text)));

  if (genre) {
    output.push(`${genre} · ${date}, ${time}`);
  } else {
    output.push(`${date}, ${time}`);
  }

  if (isEmbargoed) {
    output.push(`Sperrfrist ${title}`);
  } else {
    output.push(title);
  }

  if (by) {
    output.push(by);
  }

  output.push(body);

  output.push(`
Textinformationen
Copyright: ${creditLine}
`);

  if (hasNotes) {
    output.push("Notizblock");
  }

  if (links.length) {
    output.push(`
Internet
${formatLinkList(links)}`);
  }

  if (places.length) {
    output.push(`
Orte
${places.map(({ lines }) => `${lines.join("\n")}`)}`);
  }

  if (edservices.length) {
    output.push(`
Service
${formatList(edservices)}`);
  }

  if (editorialnotes.length) {
    output.push(`
Redaktionelle Hinweise
${formatList(editorialnotes)}`);
  }

  if (dpaContactsText.length) {
    output.push(`
Kontakte der dpa (nicht zur Veröffentlichung)
${formatList(dpaContactsText)}`);
  }

  return output.join("\n");
}

export default getPlainText;
